export enum OriginAppType {
  brandclub = 'brandclub',
  clientApp = 'clientApp',
  brandclubNetwork = 'brandclubNetwork',
}
